var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('transition',{attrs:{"name":"topin"}},[(_vm.topMessageText)?_c('topMessageBar',{on:{"exit":function($event){return _vm.changeTopMessage({text: null, status: null})}}},[_vm._v(_vm._s(_vm.topMessageText))]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }